import React from 'react';
import { APP_NAV } from '../../context/AppNavigationContext';
import { useTheme } from '../../context/ThemeContext';

export const NAV_PAGE_NAMES = {
  [APP_NAV.OVERVIEW]: 'OVERVIEW',
  [APP_NAV.TRENDS]: 'TRENDS',
  [APP_NAV.REVENUE_MOVEMENT]: 'REVENUE MOVEMENT',
  [APP_NAV.PRODUCTS]: 'PRODUCTS',
  [APP_NAV.EVENTS]: 'EVENTS',
  [APP_NAV.VENUES]: 'VENUES',
  [APP_NAV.FUNNEL]: 'FUNNEL',
  [APP_NAV.PATHS]: 'PATHS',
  [APP_NAV.SCAN_HEATMAP]: 'SCAN HEATMAP',
  [APP_NAV.CUSTOMER_SEGMENTS]: 'CUSTOMER SEGMENTS',
  [APP_NAV.REVENUE_PREDICTION]: 'REVENUE PREDICTION',
  [APP_NAV.CHAT]: 'AI ASSISTANT',
  [APP_NAV.INTEGRATIONS]: 'INTEGRATIONS',
  [APP_NAV.ACCOUNT_SETTINGS]: 'SETTINGS',
  [APP_NAV.ACCOUNT_MANAGEMENT]: 'TENANTS',
};

function formatPageLabel(pageName) {
  return pageName
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function PageHeader({ pageName = 'OVERVIEW', trailing = null }) {
  const { brandName } = useTheme();

  return (
    <header className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 pb-2 pt-0">
      <div className="min-w-0">
        <h1 className="font-display truncate text-lg font-semibold tracking-[-0.02em] text-[var(--brand-primary,#1A428A)] sm:text-xl">
          {brandName} — {formatPageLabel(pageName)}
        </h1>
        <div className="mt-2 h-0.5 w-10 rounded-full bg-[#C9A227]" />
      </div>
      {trailing ? <div className="ml-auto min-w-0 max-w-full shrink-0 pt-1">{trailing}</div> : null}
    </header>
  );
}
